// extracted by mini-css-extract-plugin
export default {"container":"ShareToChat_container_LvHtD","list":"ShareToChat_list_Rofzy","spinner":"ShareToChat_spinner_D0TFs","header":"ShareToChat_header_T2AyE","copy":"ShareToChat_copy_rJ8vO"};